export const OVERRIDE_DEBUG_MODE =
  process.env?.['NEXT_PUBLIC_ENABLE_ENERGY_DEBUG'] === 'TRUE' || false;
export const ENABLE_DEBUG = OVERRIDE_DEBUG_MODE || process.env['NODE_ENV'] === 'development';
